import { apiServiceConstants } from "../../../../constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
import {
  contactParams,
  PrimaryNumberChanged,
  PrimaryNumChanged,
  RespContactInterface,
  RespContactModel,
  RespSaveContactInterface,
  RespSaveContactModel,
  saveContactParams,
  SecondaryNumberChanged,
} from "./Models/ContactNum.model";


let alertDate: any = "";
let alertMessage: any = "";

const getContactDetails = async (
  params: contactParams
): Promise<RespContactInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/contact-list/`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const contactResp = res as RespContactModel;
      const contactResponse = setContactModel(contactResp);
      const result: RespContactInterface = {
        isSuccess: contactResp.isSuccess,
        displayContactContainer: contactResponse,
        status: contactResp.status,
        message: contactResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespContactInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayContactContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const setContactModel = (payload: RespContactModel): any => {
  let GetContactListArray = payload.result?.map((object: any) => {
    return {
      pager: object.pager,
      primaryNumber: mapPrimaryNum(object.primary_number),
      secondaryNumber: mapSecNum(object.secondary_number),
    };
  });
  return GetContactListArray;
};

const mapPrimaryNum = (primaryData: PrimaryNumberChanged) => {
  var getPGroupObject = {
    number: primaryData.number,
    type: primaryData.type,
  };
  return getPGroupObject;
};

const mapSecNum = (secData: SecondaryNumberChanged) => {
  {
    if (secData !== null) {
      secData = {
        number: secData.number,
        type: secData.type,
      };
    } else {
      secData = {
        number: "",
        type: "",
      };
    }
    return secData;
  }
};

const saveContactDetails = async (
  params: saveContactParams
): Promise<RespSaveContactInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/contact-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const saveContactResp = res as RespSaveContactModel;
      const saveContactResponse = setSaveContactModel(saveContactResp);
      const result: RespSaveContactInterface = {
        isSuccess: saveContactResp.isSuccess,
        displaySaveContactContainer: saveContactResponse,
        status: saveContactResp.status,
        message: saveContactResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespSaveContactInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displaySaveContactContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const setSaveContactModel = (payload: RespSaveContactModel): any => {
  let SaveContactListArray = payload.result?.map((object: any) => {
    return {
      pager: object.pager,
      primaryNumber: mapSavePrimaryNum(object.primary_number),
      secondaryNumber: mapSaveSecNum(object.secondary_number),
    };
  });
  return SaveContactListArray;
};

const mapSavePrimaryNum = (primaryNumData: PrimaryNumChanged) => {
  var savePGroupObject = {
    number: primaryNumData.number,
    type: primaryNumData.type,
  };
  return savePGroupObject;
};

const mapSaveSecNum = (secNumData: SecondaryNumberChanged) => {
  {
    if (secNumData !== null) {
      secNumData = {
        number: secNumData.number,
        type: secNumData.type,
      };
    } else {
      secNumData = {
        number: "",
        type: "",
      };
    }
    return secNumData;
  }
};
const handleErrorResponse = () => {};

export const ContactNumService = {
  getContactDetails,
  saveContactDetails,
  handleErrorResponse,
  alertDate,
  alertMessage,
};
